import { motion } from "framer-motion";
import { MANIFESTO, COMPANY, IMAGES } from "@/data/site";

const EASE = [0.22, 1, 0.36, 1];

export default function Manifesto() {
  return (
    <section
      id="about"
      className="relative bg-obsidian py-24 md:py-36"
      data-testid="about-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left: heading + image */}
          <div className="lg:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: EASE }}
            >
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-10 bg-spartangreen" />
                <span className="font-mono text-xs tracking-[0.25em] uppercase text-spartangreen">
                  About Our Company
                </span>
              </div>
              <h2 className="font-display uppercase tracking-tighter text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.88]">
                Built for the
                <br />
                <span className="text-spartanorange">factory floor</span>
              </h2>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
              className="mt-10 relative clip-corner overflow-hidden border border-white/10"
            >
              <img
                src={IMAGES.factory}
                alt="Spartan Packaging factory floor"
                className="w-full h-72 md:h-96 object-cover grayscale hover:grayscale-0 transition-[filter] duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-obsidian/70 to-transparent pointer-events-none" />
              <div className="absolute bottom-5 left-5 font-mono text-xs tracking-[0.2em] uppercase text-white/80">
                Est. {COMPANY.since} · {COMPANY.legal2}
              </div>
            </motion.div>
          </div>

          {/* Right: numbered chapters */}
          <div className="lg:col-span-7 lg:pl-8">
            <div className="flex flex-col">
              {MANIFESTO.map((c, i) => (
                <motion.div
                  key={c.no}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.7, ease: EASE, delay: i * 0.08 }}
                  className="group grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-8 md:py-10 border-b border-white/10 first:border-t"
                  data-testid={`manifesto-${c.no}`}
                >
                  <span className="font-mono text-sm text-spartanorange pt-2">
                    ({c.no})
                  </span>
                  <div>
                    <h3 className="font-display uppercase tracking-tight text-white text-3xl md:text-4xl group-hover:text-spartanorange transition-colors duration-300">
                      {c.title}
                    </h3>
                    <p className="mt-3 text-white/60 text-base leading-relaxed max-w-2xl">
                      {c.body}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
